module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/shootProof/modals/delete-confirmation-modal/delete-confirmation.modal.scss
// module id = ./web/modern/components/integrations/shootProof/modals/delete-confirmation-modal/delete-confirmation.modal.scss
// module chunks = 0